import domReady from 'domready';
import Modernizr from 'modernizr';

function isIeWithVersionLowerThan(version) {
    var div = document.createElement('div');

    div.innerHTML = '<!--[if lt IE ' + version + ']><i></i><![endif]-->';
    return (div.getElementsByTagName('i').length == 1);
}

domReady(function() {
    if (!Modernizr.svg || !Modernizr.csstransforms || isIeWithVersionLowerThan(10) || !Modernizr.flexbox) {
        window.location.href = "/unsupported";
    }
});
